import {
  faArrowLeft,
  faMinusCircle,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Page from "../../component/Page";
import { getBranchList, LocationList } from "../setting/services/settingApi";
import { PLAN_CONFIG } from "./config";
import PlanContext from "./services/planApi";
import api from "../../api/api";
import ConfirmPlanPrint from "./component/confirmPlanPrint";
import ConfirmDialogPs from "./component/confirmDialogPs";
import "./viewPromoteSpread.scss";
import Swal from "sweetalert2";

export default function ViewPromoteSpread() {
  const { profile, loading } = useSelector((state) => state.profile);
  const { id } = useParams();
  const navigate = useNavigate();
  const { getPlanDistributionDetail } = useContext(PlanContext);
  const [detail, setDetail] = useState();
  const [listLocation, setListLocation] = useState([]);
  const [key, setKey] = useState("");
  const [year, setYear] = useState("");
  const [BranchNo, setBranchsNo] = useState("");
  const [branchs, setBranchs] = useState([]);
  const [remark, setRemark] = useState();
  const [open, setOpen] = useState(false);
  const [openP, setOpenP] = useState(false);
  const [yearError, setyearError] = useState(false);
  const [version, setVersion] = useState('1');

  useEffect(() => {
    if (id) {
      getPlanDistributionDetail(id, setDetail);
    }
    getBranchList(null, setBranchs);
    setBranchsNo(profile?.BranchNo?.BranchNo);
  }, []);

  useEffect(() => {
    LocationList(
      {
        typeSearch: "P",
        Text: key,
      },
      setListLocation
    );
  }, [key]);

  useEffect(() => {
    if (id) {
      setBranchsNo(detail?.BranchNo?.BranchNo);
      setYear(detail?.Year);
      setRemark(detail?.Remark);
    }
  }, [detail]);

  const [months, setMonths] = useState([
    {
      name: "ตุลาคม",
      Month: 10,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "พฤศจิกายน",
      Month: 11,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "ธันวาคม",
      Month: 12,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "มกราคม",
      Month: 1,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "กุมภาพันธ์",
      Month: 2,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "มีนาคม",
      Month: 3,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "เมษายน",
      Month: 4,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "พฤษภาคม",
      Month: 5,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "มิถุนายน",
      Month: 6,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "กรกฎาคม",
      Month: 7,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "สิงหาคม",
      Month: 8,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
    {
      name: "กันยายน",
      Month: 9,
      Campaign: null,
      AgentDiscount0: null,
      AgentDiscount5: null,
      AgentDiscount8: null,
      OtherDiscount0: null,
      OtherDiscount5: null,
      Total: null,
      Province: [
        {
          provinceName: "",
          rowIndex: 1,
          DPDetailId: null,
          DPHeadId: null,
        },
      ],
    },
  ]);
  useEffect(() => {
    if (detail?.PlanDetails?.length > 0) {
      const _plan = detail?.PlanDetails.filter(
        (v, i, a) => a.findIndex((t) => t.Month === v.Month) === i
      );
      // const months = this.planDistribution.PlanDetails.map(x => x.)
      for (const c of _plan) {
        const _months = [];
        const monthDlu = detail?.PlanDetails?.filter(
          (x) => x.Month === c.Month
        );
        const find = months.find((x) => x.Month === c.Month);
        find.OtherDiscount0 = c.OtherDiscount0.toLocaleString();
        find.OtherDiscount5 = c.OtherDiscount5.toLocaleString();
        find.AgentDiscount5 = c.AgentDiscount5.toLocaleString();
        find.AgentDiscount8 = c.AgentDiscount8.toLocaleString();
        find.AgentDiscount0 = c.AgentDiscount0.toLocaleString();
        find.Campaign = c.Campaign.toLocaleString();
        find.Total = c.Total;
        for (const p of monthDlu) {
          let i = 0;
          _months.push({
            provinceName: p.ProvinceName,
            rowIndex: i++,
            DPDetailId: p.DPDetailId,
            DPHeadId: p.DPHeadId,
          });
        }
        find.Province = _months;
      }
    }
  }, [detail]);

  const handleSubmit = async () => {
    const planDetail = [];
    if (months.length > 0) {
      for (const x of months) {
        if (x.Province.length > 0) {
          for (const p of x.Province)
            if (p.provinceName) {
              planDetail.push({
                DPDetailId: p.DPDetailId || undefined,
                DPHeadId: p.DPHeadId || undefined,
                Month: x.Month,
                Campaign: +x.Campaign || 0,
                AgentDiscount0:
                  +x.AgentDiscount0?.toString().replaceAll(",", "") || 0,
                AgentDiscount5:
                  +x.AgentDiscount5?.toString().replaceAll(",", "") || 0,
                AgentDiscount8:
                  +x.AgentDiscount8?.toString().replaceAll(",", "") || 0,
                OtherDiscount0:
                  +x.OtherDiscount0?.toString().replaceAll(",", "") || 0,
                OtherDiscount5:
                  +x.OtherDiscount5?.toString().replaceAll(",", "") || 0,
                Total:
                  +x?.AgentDiscount0?.toString().replaceAll(",", "") +
                    +x?.AgentDiscount5?.toString().replaceAll(",", "") +
                    +x?.AgentDiscount8?.toString().replaceAll(",", "") +
                    +x?.Campaign?.toString().replaceAll(",", "") +
                    +x?.OtherDiscount0?.toString().replaceAll(",", "") +
                    +x?.OtherDiscount5?.toString().replaceAll(",", "") || 0,
                ProvinceName: p.provinceName,
              });
            }
        }
      }
    }
    const body = {
      BranchNo: BranchNo,
      DocumentNo: id || "",
      DocumentDate: dayjs(new Date()).format("YYYY-MM-DD"),
      Year: year,
      Remark: remark,
      PlanDetails: planDetail,
      Version: version,

    };
    const planDistributionAdd = async () => {
      if (id) {
        const url =
          PLAN_CONFIG.requests.getPlanDistribution.url + `/${body?.DocumentNo}`;
        const res = await api.put(url, body);
        const data = res.data;
        if (data.status === true) {
          setOpen(false);
          setOpenP(true);
        }
      } else {
        const res = await api.post(
          PLAN_CONFIG.requests.getPlanDistribution.url,
          body
        );
        const data = res.data;
        if (data.status === true) {
          navigate("/plan/promote-spread/" + data.result.DocumentNo);
          setOpen(false);
          setOpenP(true);
        } else {
          Swal.fire({
            title: data?.message || "ทำรายการไม่สำเร็จ",
            icon: "warning",
          });
        }
      }
    };
    planDistributionAdd();
  };
  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <form>
          <div class="container-fluid">
            <div class="d-flex row align-items-center ">
              <div class="col-12">
                <label class="title-content mb-4">
                  ข้อมูลแผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว
                </label>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <FormControl variant="standard" fullWidth>
                    <Select
                      value={BranchNo || ""}
                      onChange={(e) => setBranchsNo(e.target.value)}
                      disableUnderline
                    >
                      {branchs?.map((x) => (
                        <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div class="col-lg-4 col-md-6">
                <label class="labelInput">ปีงบประมาณ</label>
                <Box className={`backgroundField ${yearError ? "error" : ""}`}>
                  <TextField
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    variant="standard"
                    fullWidth
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setyearError(true);
                      } else {
                        setyearError(false);
                      }
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
                {yearError && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    กรุณาเลือกปีงบประมาณ
                  </span>
                )}
              </div>
              <div class="col-lg-4 col-md-6 row align-items-center">
                <RadioGroup
                  value={version || ""}
                  onChange={(e) => setVersion(e.target.value)}
                  row
                >
                  <FormControlLabel
                    value="1"
                    disabled={id}
                    control={<Radio />}
                    label="ครั้งที่ 1 (ต.ค. - ก.ย.)"
                  />
                  <FormControlLabel
                    value="2"
                    disabled={id}
                    control={<Radio />}
                    label="ครั้งที่ 2 (เม.ย. - ก.ย.)"
                  />
                </RadioGroup>
              </div>
            </div>
            {id && (
              <div class="row">
                <div class="col-lg-4 col-md-6">
                  <label class="labelInput me-3">ผู้สร้าง</label>{" "}
                  <label class="message-error-label">
                    ( {dayjs(detail?.CreateDate).format("DD/MM/BBBB")} )
                  </label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled
                      value={detail?.CreateId}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-6">
                  <label class="labelInput me-3">ผู้แก้ไข</label>{" "}
                  <label class="message-error-label">
                    ( {dayjs(detail?.ModifiedDate).format("DD/MM/BBBB")} )
                  </label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled
                      value={detail?.ModifiedId}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
              </div>
            )}
            <div class="row">
              <div class="col-lg-8 col-md-12">
                <label class="labelInput">หมายเหตุ</label>
                <Box
                  className="backgroundField"
                  sx={{ marginBottom: "10px", borderRadius: "25px" }}
                >
                  <TextField
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    variant="standard"
                    fullWidth
                    multiline
                    rows={3}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="viewPromoteSpread row">
              <div class="text-end " style={{ color: "red" }}>
                ( หน่วย : ตัน )
              </div>
              <div
                class="col-md-12 table-responsive-sm pb-3"
                style={{ height: "auto" }}
              >
                <table class="table table-bordered table-hover ">
                  <thead>
                    <tr>
                      <th
                        scope="col "
                        rowspan="3"
                        class="text-center"
                        style={{ width: "10%" }}
                      >
                        ช่วงเวลา(เดือน)
                      </th>
                      <th scope="col " colspan="6" class="text-center">
                        สัดส่วนช่องทางการจำหน่าย
                      </th>
                      <th scope="col " rowspan="3" class="text-center">
                        รวม
                      </th>
                      <th scope="col " rowspan="3" class="text-center">
                        สถานที่ที่จะส่งเสริม (ระบุจังหวัด)
                      </th>
                    </tr>
                    <tr>
                      <th scope="col " rowspan="2" class="text-center">
                        โครงการ/ส่วนราชการ
                      </th>
                      <th scope="col " colspan="3" class="text-center">
                        ตัวแทนจำหน่าย
                      </th>
                      <th scope="col " colspan="2" class="text-center">
                        เกษตรกร/กลุ่มเกษตรกร/ร้านค้า
                      </th>
                    </tr>
                    <tr>
                      <th scope="col " class="text-center">
                        ราคาเต็ม
                      </th>
                      <th scope="col " class="text-center">
                        ลด 5%
                      </th>
                      <th scope="col " class="text-center">
                        ลด 8%
                      </th>
                      <th scope="col " class="text-center">
                        ราคาเต็ม
                      </th>
                      <th scope="col " class="text-center">
                        ส่วนลด
                      </th>
                    </tr>
                  </thead>
                  <tbody class="">
                    {months?.map((x) => (
                      <tr>
                        <td>{x.name}</td>
                        <td>
                          <TextField
                            value={x?.Campaign}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = months?.map((v) => {
                                v.Campaign =
                                  v?.Month === x?.Month ? abc : v?.Campaign;
                                return v;
                              });
                              setMonths(item);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td>
                          <TextField
                            value={x?.AgentDiscount0}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = months?.map((v) => {
                                v.AgentDiscount0 =
                                  v?.Month === x?.Month
                                    ? abc
                                    : v?.AgentDiscount0;
                                return v;
                              });
                              setMonths(item);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td>
                          <TextField
                            value={x?.AgentDiscount5}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = months?.map((v) => {
                                v.AgentDiscount5 =
                                  v?.Month === x?.Month
                                    ? abc
                                    : v?.AgentDiscount5;
                                return v;
                              });
                              setMonths(item);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td>
                          <TextField
                            value={x?.AgentDiscount8}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = months?.map((v) => {
                                v.AgentDiscount8 =
                                  v?.Month === x?.Month
                                    ? abc
                                    : v?.AgentDiscount8;
                                return v;
                              });
                              setMonths(item);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td>
                          <TextField
                            value={x?.OtherDiscount0}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = months?.map((v) => {
                                v.OtherDiscount0 =
                                  v?.Month === x?.Month
                                    ? abc
                                    : v?.OtherDiscount0;
                                return v;
                              });
                              setMonths(item);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td>
                          <TextField
                            value={x?.OtherDiscount5}
                            size="small"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => {
                              let newValue = e.target.value.replace(/,/g, "");

                              let abc = newValue.replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              );
                              const item = months?.map((v) => {
                                v.OtherDiscount5 =
                                  v?.Month === x?.Month
                                    ? abc
                                    : v?.OtherDiscount5;
                                return v;
                              });
                              setMonths(item);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </td>
                        <td class="text-center">
                          {parseFloat(
                            +(x?.AgentDiscount0 || 0)
                              .toString()
                              .replaceAll(",", "") +
                              +(x?.AgentDiscount5 || 0)
                                .toString()
                                .replaceAll(",", "") +
                              +(x?.AgentDiscount8 || 0)
                                .toString()
                                .replaceAll(",", "") +
                              +(x?.Campaign || 0)
                                .toString()
                                .replaceAll(",", "") +
                              +(x?.OtherDiscount0 || 0)
                                .toString()
                                .replaceAll(",", "") +
                              +(x?.OtherDiscount5 || 0)
                                .toString()
                                .replaceAll(",", "")
                          )
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                        </td>
                        <td>
                          {x?.Province?.map((y, index) => (
                            <div
                              class="d-flex align-items-center"
                              style={{ margin: "5px 0" }}
                            >
                              <Autocomplete
                                sx={{ width: "100%", marginRight: "5px" }}
                                value={y?.provinceName}
                                onChange={(event, newValue) => {
                                  const item = months?.map((v) => {
                                    v.Province =
                                      v?.Month === x?.Month
                                        ? v.Province?.map((c, i) => {
                                            c.provinceName =
                                              i === index
                                                ? newValue
                                                : c.provinceName;

                                            return c;
                                          })
                                        : v?.Province;
                                    return v;
                                  });
                                  setMonths(item);
                                }}
                                onInputChange={(event, newInputValue) => {
                                  setKey(newInputValue);
                                }}
                                options={
                                  listLocation.length > 0
                                    ? listLocation
                                        .filter(
                                          (v, i, a) =>
                                            a.findIndex(
                                              (t) =>
                                                t.ProvinceId === v.ProvinceId
                                            ) === i
                                        )
                                        ?.map((option) => option?.ProvinceName)
                                    : []
                                }
                                renderInput={(params) => (
                                  <Box ref={params.InputProps.ref}>
                                    <OutlinedInput
                                      {...params.inputProps}
                                      fullWidth
                                      size="small"
                                      sx={{ padding: "0 !important" }}
                                    />
                                  </Box>
                                )}
                              />
                              {index === 0 ? (
                                <FontAwesomeIcon
                                  icon={faPlusCircle}
                                  style={{ width: "40px" }}
                                  onClick={() => {
                                    x?.Province.push({
                                      provinceName: "",
                                      rowIndex: x?.Province?.slice(-1)[0]
                                        ?.rowIndex
                                        ? x?.Province?.slice(-1)[0]?.rowIndex +
                                          1
                                        : 1,
                                      DPDetailId: null,
                                      DPHeadId: null,
                                    });
                                    const item = months?.map((v) => {
                                      v.Province =
                                        v?.Month === x?.Month
                                          ? x?.Province
                                          : v?.Province;
                                      return v;
                                    });
                                    setMonths(item);
                                  }}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faMinusCircle}
                                  style={{
                                    width: "40px",
                                    "&.fa-circle-minus": {
                                      fontSize: "1.7rem !important",
                                    },
                                  }}
                                  onClick={() => {
                                    const item = months?.map((v) => {
                                      v.Province =
                                        v?.Month === x?.Month
                                          ? x.Province?.filter(
                                              (e, i) => index !== i
                                            )
                                          : v?.Province;

                                      return v;
                                    });
                                    setMonths([...item]);
                                  }}
                                />
                              )}
                            </div>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <hr class="chr" />
            <div class="row mt-4">
              <div class="col-12 ">
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                  sx={{ width: "130px", fontSize: "14px", marginRight: "10px" }}
                >
                  กลับ
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (!year) {
                      setyearError(true);
                    } else {
                      setOpen(true);
                    }
                  }}
                  sx={{ width: "130px", fontSize: "14px" }}
                >
                  {id ? "เเก้ไข" : "บันทึก"}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </Page>
      <ConfirmPlanPrint
        title={"บันทึกรายการแผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว"}
        download={null}
        open={openP}
        setOpen={setOpenP}
        loadingPDF={null}
        linkTo="/plan/promote-spread/add"
      />
      <ConfirmDialogPs
        open={open}
        setOpen={setOpen}
        rows={months}
        handleAdd={handleSubmit}
      />
    </div>
  );
}
